import HashtagIcon from "@/assets/icons/hashtag.svg";
import { useEpisode } from "@/containers/Episode/context";
import Highlight from "@components/Highlight";

const Toplist: React.FunctionComponent = () => {
  const { toplist } = useEpisode();

  if (!(toplist && toplist.length)) return null;

  const getLabel = ({
    place,
    genre,
    source,
  }: {
    place: string;
    genre: string;
    source: string;
  }) => {
    let sourceString = "";
    if (source === "itunes") sourceString = "Apple iTunes";
    else if (source === "spotify") sourceString = "Spotify";

    return `${place} ${L.TOPLIST_BADGE_ON} ${sourceString}${
      genre ? `: ` + genre : ""
    }`;
  };

  return (
    <>
      {toplist?.map((item, i) => (
        <Highlight
          label={getLabel(item)}
          icon={HashtagIcon}
          key={`toplist-highlight-${i}`}
          data-testid="toplist"
        />
      ))}
    </>
  );
};

export default Toplist;
